export enum OfferType {
  BOARDS_BEYOND = 'boardsbeyond',
  CLINICAL_REASONING = 'clinical-reasoning',
  CONNECT_LOOSELEAF_DISCOUNTED = 'connectlooseleafdiscounted',
  CUSTOM = 'privatebook',
  EBOOK = 'ebook',
  EBOOK_CREATE = 'custombook',
  EBOOK_MHP = 'ebooks',
  EBOOK_PURCHASE = 'ebookpurchase',
  EBOOK_RENTAL = 'ebookrental',
  FIRST_AID_FORWARD = 'dfa',
  GDP = 'gdp',
  GO = 'go',
  PRINT_MHP = 'print',
  VIRTUAL_LABS = 'virtual-labs',
  ALEKS = 'aleks',
  SHARPEN_COMPANION = 'sharpen-companion',
}

export class OfferTypeChecker {
  static isBoardsBeyond(offerType?: string): boolean {
    return typeCheck(OfferType.BOARDS_BEYOND, offerType);
  }

  static isFirstAidForward(offerType?: string): boolean {
    return typeCheck(OfferType.FIRST_AID_FORWARD, offerType);
  }

  static isClinicalReasoning(offerType?: string): boolean {
    return typeCheck(OfferType.CLINICAL_REASONING, offerType);
  }

  static isGdp(offerType?: string): boolean {
    return typeCheck(OfferType.GDP, offerType);
  }

  static isGo(offerType?: string): boolean {
    return typeCheck(OfferType.GO, offerType);
  }

  static isConnectLLDiscounted(offerType?: string): boolean {
    return typeCheck(OfferType.CONNECT_LOOSELEAF_DISCOUNTED, offerType);
  }

  static isCreateEbook(offerType?: string): boolean {
    return typeCheck(OfferType.EBOOK_CREATE, offerType);
  }

  static isCustom(offerType?: string): boolean {
    return typeCheck(OfferType.CUSTOM, offerType);
  }

  static isCreateCustom(offerType?: string): boolean {
    return [OfferType.EBOOK_CREATE, OfferType.CUSTOM].includes(getLowerCaseType(offerType));
  }

  static isMhpEbook(offerType?: string): boolean {
    return typeCheck(OfferType.EBOOK_MHP, offerType);
  }

  static isMhpPrint(offerType?: string): boolean {
    return typeCheck(OfferType.PRINT_MHP, offerType);
  }

  static isEbook(offerType?: string): boolean {
    return [
      OfferType.EBOOK,
      OfferType.EBOOK_CREATE,
      OfferType.EBOOK_MHP,
      OfferType.EBOOK_PURCHASE,
      OfferType.EBOOK_RENTAL,
    ].includes(getLowerCaseType(offerType));
  }

  static isVirtualLabs(offerType?: string): boolean {
    return typeCheck(OfferType.VIRTUAL_LABS, offerType);
  }

  static isHeEbook(offerType?: string): boolean {
    return [OfferType.EBOOK, OfferType.EBOOK_PURCHASE, OfferType.EBOOK_RENTAL].includes(getLowerCaseType(offerType));
  }

  static isAleks(offerType?: string): boolean {
    return typeCheck(OfferType.ALEKS, offerType);
  }

  static isSharpenCompanion(offerType?: string): boolean {
    return typeCheck(OfferType.SHARPEN_COMPANION, offerType);
  }
}

function getLowerCaseType(offerType?: string): OfferType {
  return offerType?.toLowerCase() as OfferType;
}

function typeCheck(type: OfferType, value?: string): boolean {
  return getLowerCaseType(value) === type;
}
